// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__lE1gF","bigColWidth":"Table_bigColWidth__2g8Fm","biggerColWidth":"Table_biggerColWidth__1fBgt","row":"Table_row__1f-hE","col":"Table_col__wmQUT"};